import { Link } from "react-router-dom"
import { ChangelogReportBreadcrumb } from "@/components/changelog-report-breadcrumb"
import { SiteHeader } from "@/components/site-header"
import { Badge } from "@/components/ui/badge"

/** Última verificación: db:fresh + db:seed + db:seed:routes (misma sesión) — 2026-05-11 */
const RUN = {
  date: "2026-05-11",
  sourcePath: "apps/api/data/20160511/localidades-20260511.txt",
  fileLines: 1645,
  inserted: 1562,
  conflictSkipped: 1,
  unresolved: 20,
}

/** Misma sesión que RUN — salida final de db:seed:routes */
const ROUTES_RUN = {
  inserted: 6432,
  skippedExisting: 0,
  unresolved: 764,
}

/** Filas vacías o truncadas que el seeder omite sin insertar */
const SKIPPED = [
  { code: "RINCON", reason: "Fila vacía — sin estado ni país" },
  { code: "SAN JOSE(U", reason: "Fila truncada" },
  { code: "VILA", reason: "Fila vacía — sin estado ni país" },
  { code: "LAUTARO CH", reason: "Estado ALT+CL no existe en DB" },
  { code: "MINGA GUAZ", reason: "Estado ALT+PY no existe en DB" },
  { code: "SAN FELIPE", reason: "AFE pertenece a UY, no a CL" },
]

/** Inconsistencias de archivo / jerarquía — sin parche en el seeder */
const SOURCE_MISMATCHES = [
  { code: "JUNIN/CHIV", note: "Provincia/país en fuente no coincide con lugar real" },
  { code: "URUG / EZE", note: "Idem" },
  { code: "ROSA / V.M", note: "Idem" },
  { code: "S.FE/CORDO", note: "Idem" },
  { code: "IBIA", note: "Idem" },
  { code: "UBERLANDIA", note: "Idem (MIN+MIN en fuente)" },
  { code: "SORIANO", note: "Idem" },
  { code: "GUARAREMAS", note: "Idem" },
  { code: "ITIBAIA", note: "Idem" },
  { code: "JACAREI", note: "Idem" },
  { code: "S.BOR/OSAS", note: "Idem" },
  { code: "TARUIJA", note: "TAR+AR en fuente; Tarija es BO" },
  { code: "COLONIA UY", note: "CTE+UY incompatible con jerarquía actual" },
  { code: "VILLAZON", note: "BUE+BO — falta Potosí en states" },
]

/** No resueltas en la última corrida (consola del seeder de ciudades) */
const LAST_UNRESOLVED = [
  { code: "SANTA CRUA", reason: "estado SCA+AR no encontrado" },
  { code: "SIN DESTIN", reason: "estado NS+AR no encontrado" },
  { code: "SIN ORIGEN", reason: "estado NS+AR no encontrado" },
  { code: "C. BARBOSA", reason: "estado RS+BR no encontrado" },
  { code: "CACHO", reason: "estado RS+BR no encontrado" },
  { code: "CHAPE/URUG", reason: "estado RS+BR no encontrado" },
  { code: "FREDERICO", reason: "estado RS+BR no encontrado" },
  { code: "GRAMADO", reason: "estado RS+BR no encontrado" },
  { code: "IJUI", reason: "estado RS+BR no encontrado" },
  { code: "POSSO FUND", reason: "estado RS+BR no encontrado" },
  { code: "RESTINGA", reason: "estado RS+BR no encontrado" },
  { code: "SALDANHA", reason: "estado RS+BR no encontrado" },
  { code: "SANGELO", reason: "estado RS+BR no encontrado" },
  { code: "SAPIRANGA", reason: "estado RS+BR no encontrado" },
  { code: "SF DE PAUL", reason: "estado RS+BR no encontrado" },
  { code: "SFDP/ROSAR", reason: "estado RS+BR no encontrado" },
  { code: "TAINHAS", reason: "estado RS+BR no encontrado" },
  { code: "UBERLANDIA", reason: "país MIN no encontrado" },
  { code: "URUGUAIANA", reason: "estado RS+BR no encontrado" },
  { code: "TARUIJA", reason: "estado TAR+AR no encontrado" },
]

const DUPLICATES = [
  { name: "Buenos Aires / Mar Del Plata", prov: "BUE", country: "AR", inDb: "BSMDQ", lost: "MDQBSAS" },
  { name: "Campos Dos Goytacazes", prov: "RJ", country: "BR", inDb: "CAM.GOYTAZ", lost: "GOYTACAZES" },
  { name: "Colon / Buenos Aires", prov: "BUE", country: "AR", inDb: "COLON/BSAS", lost: "CONLON/BSA" },
  { name: "Embu / Suzano", prov: "SP", country: "BR", inDb: "EMBU / SUZ", lost: "EMBU/SUZAN" },
  { name: "Estrada Bruno", prov: "SC", country: "BR", inDb: "25DMAYO", lost: "ESTRADA" },
  { name: "Gobernador Virasoro", prov: "MIS", country: "AR", inDb: "G.VIRASORO", lost: "VIRASORO" },
  { name: "La Cañada", prov: "SAL", country: "AR", inDb: "CAÑADA", lost: "LACAÑADA" },
  { name: "La Rioja / Catamarca / Tuc", prov: "TUC", country: "AR", inDb: "RIOCATTUC", lost: "LAR/CA/TU" },
  { name: "Mendoza / Chivicloy", prov: "BUE", country: "AR", inDb: "MENDOCHIVI", lost: "MENCHU" },
  { name: "Monte Chingolo", prov: "BUE", country: "AR", inDb: "MCHINGO", lost: "MONTE CHIN" },
  { name: "Paso De Los Libres", prov: "CTE", country: "AR", inDb: "3CORA/CORD", lost: "PASO DE LO" },
  { name: "Puerto Esperanza", prov: "MIS", country: "AR", inDb: "ESPERANZA", lost: "PUERTO ESP" },
  { name: "Puerto Madryn", prov: "CHU", country: "AR", inDb: "PMADRYN", lost: "PUERTO MAD" },
  { name: "Rio Cuarto", prov: "COR", country: "AR", inDb: "R4", lost: "RIO CUARTO" },
  { name: "Salta / Guemes / Rdf / Metan", prov: "SAL", country: "AR", inDb: "SALGUERDFM", lost: "SLGUERDFME" },
  { name: "Salta / Lib / Tartagal", prov: "SAL", country: "AR", inDb: "SAL/LI/TAR", lost: "SAL/LIB/TA" },
  { name: "San Antonio De Areco", prov: "BUE", country: "AR", inDb: "SAARECO", lost: "SAN ANT.AR" },
  { name: "San Jose (Misiones)", prov: "MIS", country: "AR", inDb: "S. JOSE AR", lost: "SAN J (MNS" },
  { name: "San Juan", prov: "SJU", country: "AR", inDb: "SAN JUAN", lost: "SAN JUAN C" },
  { name: "San Juan / Mendoza", prov: "MEN", country: "AR", inDb: "SJ/MENDOZA", lost: "SJMENDOZA" },
  { name: "San Martin", prov: "BUE", country: "AR", inDb: "SAN MARTIN", lost: "SMARTIN" },
  { name: "San Pedro / Oran / Tartagal", prov: "SAL", country: "AR", inDb: "SPORTAR", lost: "SPORTARTA" },
  { name: "San Pedro Juj / Libertador", prov: "JUJ", country: "AR", inDb: "SPED/LIBER", lost: "SP/LIB" },
  { name: "Santa Barbara Do Oeste", prov: "SP", country: "BR", inDb: "SANTA BARB", lost: "SBDO" },
  { name: "Santa Fe / Buenos Aires", prov: "BUE", country: "AR", inDb: "SFE/BSAS", lost: "SFEBSAS" },
  { name: "Santa Rosa", prov: "LP", country: "AR", inDb: "SANTA ROSA", lost: "STAROSA" },
  { name: "Sao Joao Da Boa Vista", prov: "SP", country: "BR", inDb: "SAO JOAO D", lost: "SAOJDBVIST" },
  { name: "Santa Fe", prov: "SFE", country: "AR", inDb: "SANTAFE", lost: "STAFE" },
  { name: "Tucuman / Bs As", prov: "BUE", country: "AR", inDb: "TUC/BSAS", lost: "TUCUM/BSAS" },
  { name: "Villa Adelina", prov: "BUE", country: "AR", inDb: "VILLA ADEL", lost: "VILLA DELI" },
  { name: "Villa Soldati", prov: "BUE", country: "AR", inDb: "V SOLDATI", lost: "VSOLDATI" },
  { name: "Villa Soldati (2)", prov: "BUE", country: "AR", inDb: "VSOLDATI", lost: "(idem)" },
]

export default function GeoImportReportPage() {
  return (
    <>
      <SiteHeader
        title="Importación"
        breadcrumb={<ChangelogReportBreadcrumb currentLabel="Localidades · 2026-05-11" />}
      />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <div className="max-w-5xl space-y-10">
          <div className="space-y-3 rounded-lg border border-emerald-200 bg-emerald-50/80 dark:bg-emerald-950/20 dark:border-emerald-900 p-4 text-sm">
            <p className="font-medium text-foreground">Estado verificado ({RUN.date})</p>
            <p className="text-muted-foreground">
              Verificación en la misma sesión: <code className="font-mono text-xs bg-muted px-1 rounded">db:fresh</code>{" "}
              (incluye <code className="font-mono text-xs bg-muted px-1 rounded">bun run db:seed</code>: países,
              provincias, ciudades, usuarios demo) y luego{" "}
              <code className="font-mono text-xs bg-muted px-1 rounded">bun run db:seed:routes</code>. Ciudades en{" "}
              <code className="font-mono text-xs bg-muted px-1 rounded">apps/api/src/db/seeds/cities-data.ts</code>,
              alineadas con{" "}
              <code className="font-mono text-xs bg-muted px-1 rounded">{RUN.sourcePath}</code> ({RUN.fileLines} líneas,
              cabecera incluida). Rutas: {ROUTES_RUN.inserted} insertadas, {ROUTES_RUN.skippedExisting} ya existían,{" "}
              {ROUTES_RUN.unresolved} no resueltas — detalle en{" "}
              <Link to="/reports/routes-import" className="text-foreground underline underline-offset-2">
                reporte de rutas
              </Link>
              .
            </p>
          </div>

          <div className="space-y-3 rounded-lg border border-amber-200 bg-amber-50/80 dark:bg-amber-950/20 dark:border-amber-900 p-4 text-sm">
            <p className="font-medium text-foreground">Comportamiento del seeder</p>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>
                No corrige país ni código de provincia en caliente: lo que no resuelve contra{" "}
                <code className="font-mono text-xs bg-muted px-1 rounded">countries</code> /{" "}
                <code className="font-mono text-xs bg-muted px-1 rounded">states</code> queda como{" "}
                <strong>no resuelto</strong> en consola.
              </li>
              <li>
                Nombre en DB: formato título por tramo con « / » (ej.{" "}
                <em>Apostoles / J America / Bs As</em>), igual que el nombre de ruta en{" "}
                <code className="font-mono text-xs bg-muted px-1 rounded">db:seed:routes</code>.
              </li>
              <li>
                <strong>RS vs RGS (Brasil):</strong> la provincia en DB es <code className="text-xs">RGS</code>; muchas
                filas de la fuente usan <code className="text-xs">RS</code> → aparecen como no resueltas hasta
                normalizar la fuente o el dataset embebido.
              </li>
            </ul>
          </div>

          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">
              Fuente de referencia:{" "}
              <code className="font-mono text-xs bg-muted px-1.5 py-0.5 rounded">{RUN.sourcePath}</code>
            </p>
          </div>

          <section>
            <h2 className="text-base font-semibold mb-3">Resumen ({RUN.date})</h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {[
                { label: "Insertadas", value: String(RUN.inserted), color: "text-green-700" },
                { label: "Ya existían (mismo código + prov.)", value: String(RUN.conflictSkipped), color: "text-amber-700" },
                { label: "No resueltas", value: String(RUN.unresolved), color: "text-red-600" },
                { label: "Líneas archivo", value: String(RUN.fileLines), color: "text-muted-foreground" },
              ].map((s) => (
                <div key={s.label} className="rounded-lg border p-3">
                  <p className={`text-2xl font-bold tabular-nums ${s.color}`}>{s.value}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{s.label}</p>
                </div>
              ))}
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              Insertadas + conflicto + no resueltas = {RUN.inserted + RUN.conflictSkipped + RUN.unresolved} filas con
              datos intentadas; el resto son filas vacías u omitidas en el array del seeder.
            </p>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3">
              <Badge variant="outline" className="text-red-600 border-red-300">
                No importadas
              </Badge>
              <h2 className="text-base font-semibold">Filas vacías / truncadas (referencia)</h2>
            </div>
            <div className="rounded-lg border overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left px-3 py-2 font-medium">Código</th>
                    <th className="text-left px-3 py-2 font-medium">Motivo</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {SKIPPED.map((s) => (
                    <tr key={s.code}>
                      <td className="px-3 py-2 font-mono text-xs">{s.code}</td>
                      <td className="px-3 py-2 text-muted-foreground">{s.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3">
              <Badge variant="outline" className="text-amber-600 border-amber-300">
                Última corrida
              </Badge>
              <h2 className="text-base font-semibold">No resueltas (consola)</h2>
            </div>
            <div className="rounded-lg border overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left px-3 py-2 font-medium">Código / grupo</th>
                    <th className="text-left px-3 py-2 font-medium">Motivo</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {LAST_UNRESOLVED.map((r) => (
                    <tr key={r.code}>
                      <td className="px-3 py-2 font-mono text-xs">{r.code}</td>
                      <td className="px-3 py-2 text-muted-foreground">{r.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-3">
              <Badge variant="outline" className="text-amber-600 border-amber-300">
                Fuente
              </Badge>
              <h2 className="text-base font-semibold">Inconsistencias documentadas (sin parche en seeder)</h2>
            </div>
            <div className="rounded-lg border overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left px-3 py-2 font-medium">Código</th>
                    <th className="text-left px-3 py-2 font-medium">Nota</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {SOURCE_MISMATCHES.map((r) => (
                    <tr key={r.code}>
                      <td className="px-3 py-2 font-mono text-xs">{r.code}</td>
                      <td className="px-3 py-2 text-muted-foreground">{r.note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-2">
              <Badge variant="outline" className="text-amber-600 border-amber-300">
                Duplicados
              </Badge>
              <h2 className="text-base font-semibold">
                {RUN.conflictSkipped} inserciones omitidas por conflicto (código logístico + provincia ya existía)
              </h2>
            </div>
            <p className="text-sm text-muted-foreground mb-3">
              Referencia de pares en la fuente (mismo topónimo, códigos distintos o truncados). Con la unicidad actual
              por <code className="font-mono text-xs bg-muted px-1 rounded">(code, state_id)</code> (
              <code className="font-mono text-xs bg-muted px-1 rounded">uq_cities_code_state</code>) solo se omite la
              inserción cuando el <strong>mismo</strong> código vuelve a aparecer para esa provincia; nombres repetidos
              con códigos distintos pueden coexistir.
            </p>
            <div className="rounded-lg border overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left px-3 py-2 font-medium">Nombre geográfico</th>
                    <th className="text-left px-3 py-2 font-medium">Prov</th>
                    <th className="text-left px-3 py-2 font-medium">País</th>
                    <th className="text-left px-3 py-2 font-medium">Encontrado</th>
                    <th className="text-left px-3 py-2 font-medium text-blue-600">Duplicado</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {DUPLICATES.map((d, i) => (
                    <tr key={i}>
                      <td className="px-3 py-2 text-muted-foreground text-xs">{d.name}</td>
                      <td className="px-3 py-2 font-mono text-xs">{d.prov}</td>
                      <td className="px-3 py-2 font-mono text-xs">{d.country}</td>
                      <td className="px-3 py-2 font-mono text-xs text-green-700">{d.inDb}</td>
                      <td className="px-3 py-2 font-mono text-xs text-blue-500">{d.lost}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-3">Pendientes</h2>
            <ol className="space-y-2 text-sm text-muted-foreground list-decimal list-inside">
              <li>
                <strong className="text-foreground">Fuente y provincias</strong>: unificar{" "}
                <code className="font-mono text-xs bg-muted px-1 rounded">RS</code> vs{" "}
                <code className="font-mono text-xs bg-muted px-1 rounded">RGS</code>, corregir países erróneos y dar de
                alta estados faltantes (Potosí BO, etc.).
              </li>
              <li>
                <strong className="text-foreground">Trayectos</strong>: muchos códigos de ciudad del TSV no coinciden
                con <code className="font-mono text-xs bg-muted px-1 rounded">cities.code</code> (truncados o distintos)
                — ver{" "}
                <Link to="/reports/routes-import" className="text-foreground underline underline-offset-2">
                  reporte de rutas
                </Link>
                .
              </li>
              <li>
                <strong className="text-foreground">Estados ALT (CL y PY)</strong>: definir en DB para localidades
                pendientes (p. ej. LAUTARO CH, MINGA GUAZ en análisis histórico).
              </li>
            </ol>
          </section>
        </div>
      </div>
    </>
  )
}
